import React from 'react';
import { TextInput } from '@abyss/ui/form/TextInput';
import { Flex } from '@abyss/ui/base/Flex';

export const EmulatedInput = () => {
  return (
    <React.Fragment>
      <Flex gutters>
        <Flex.Content space-40>Emulated UUID:</Flex.Content>
        <Flex.Content>
          <TextInput
            data-testid="emulated-uuid"
            model="internalPreference.uuid"
            validators={{ required: value => !value }}
          />
        </Flex.Content>
      </Flex>
      <Flex gutters>
        <Flex.Content space-40>Emulated One Healthcare ID:</Flex.Content>
        <Flex.Content>
          <TextInput
            data-testid="emulated-ohid-id"
            model="internalPreference.ohid"
            validators={{ required: value => !value }}
          />
        </Flex.Content>
      </Flex>
    </React.Fragment>
  );
};
